// import { useQuery } from '@tanstack/react-query';
// import { sellerServices } from '../services/seller.service';

// export const useSeller = (sellerId) => {
//   return useQuery({
//     queryKey: ['seller', sellerId],
//     queryFn: () => sellerServices.getSeller(sellerId),
//     enabled: !!sellerId,
//     staleTime: 1000 * 60 * 5, // 5 minutes
//   });
// };


import { useQuery } from '@tanstack/react-query';
import { sellerServices } from '../services/seller.service';

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get single seller
 */
export const useSeller = (sellerId) => {
  return useQuery({
    queryKey: ['seller', sellerId],

    queryFn: async () => {
      try {
        return await sellerServices.getSeller(sellerId);
      } catch (error) {
        throw parseApiError(error);
      }
    },

    enabled: !!sellerId,

    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes

    retry: 1,
  });
};